import { FC } from "react";

import formStyles from "../form/form.module.css";
import { Select } from "../select";
import { padTimePart } from "./dateTimeValue";
import styles from "./DateTimePicker.module.css";

const toOptions = (count: number) =>
  Array.from({ length: count }, (_, index) => ({
    value: padTimePart(index),
    label: padTimePart(index),
  }));

const HOURS = toOptions(24);
const MINUTES = toOptions(60);

interface Props {
  hours: number;
  minutes: number;
  onChange: (hours: number, minutes: number) => void;
}

export const TimeFields: FC<Props> = ({ hours, minutes, onChange }) => (
  <div className={styles.time}>
    <span className={styles.timeLabel}>Time</span>
    <Select
      options={HOURS}
      value={padTimePart(hours)}
      className={formStyles.input}
      onChange={(next) => onChange(Number(next), minutes)}
    />
    <span>:</span>
    <Select
      options={MINUTES}
      value={padTimePart(minutes)}
      className={formStyles.input}
      onChange={(next) => onChange(hours, Number(next))}
    />
  </div>
);
